import { GameEventTypeCode } from '../../enums';
import { Play } from '../../types';

export const GAME_STOPPED_EVENTS = [
    // TODO where does this belong
    // GameEvents.DelayedPenalty,
    GameEventTypeCode.GAME_END,
    GameEventTypeCode.PERIOD_END,
    GameEventTypeCode.PERIOD_START,
    GameEventTypeCode.SHOOTOUT_COMPLETE,
    GameEventTypeCode.STOPPAGE,
];

export const EXPANDABLE_EVENTS = [
    GameEventTypeCode.FACEOFF,
    GameEventTypeCode.HIT,
    GameEventTypeCode.GIVEAWAY,
    GameEventTypeCode.GOAL,
    GameEventTypeCode.SHOT_ON_GOAL,
    GameEventTypeCode.MISSED_SHOT,
    GameEventTypeCode.BLOCKED_SHOT,
    GameEventTypeCode.PENALTY,
    GameEventTypeCode.TAKEAWAY,
];

export const ALL_OPTIONS = 'ALL';

export const getUniqueValues = <S, T>(items: Array<S>, field: string) => {
    const uniqueItems: Array<T> = [];
    items.forEach((item) => {
        const value = item?.[field];
        if (!uniqueItems.includes(value)) {
            uniqueItems.push(value);
        }
    });
    return uniqueItems;
};

export const findMatchingPlayer = (play: Play, playerId: number) =>
    [
        play.details?.playerId,
        play.details?.assist1PlayerId,
        play.details?.assist2PlayerId,
        play.details?.scoringPlayerId,
        play.details?.shootingPlayerId,
        play.details?.blockingPlayerId,
        play.details?.goalieInNetId,
        play.details?.committedByPlayerId,
        play.details?.drawnByPlayerId,
        play.details?.losingPlayerId,
        play.details?.winningPlayerId,
        play.details?.hitteePlayerId,
        play.details?.hittingPlayerId,
    ].includes(playerId);
